// extracted by mini-css-extract-plugin
export default {"turns":"_19_AS3UhupJSAVhwaS1ELH","backgroundLeft":"_1w25OxiRf1HlqTUAYXjWlV","backgroundRight":"_1Ity6VOZGzjWjjhsQRzurK"};